/* tslint:disable */
/* eslint-disable */
/**
 * FraudFighter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PackageDto,
    PackageDtoFromJSON,
    PackageDtoFromJSONTyped,
    PackageDtoToJSON,
    TeamMemberDto,
    TeamMemberDtoFromJSON,
    TeamMemberDtoFromJSONTyped,
    TeamMemberDtoToJSON,
} from './';

/**
 * 
 * @export
 * @interface TeamDto
 */
export interface TeamDto {
    /**
     * 
     * @type {string}
     * @memberof TeamDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamDto
     */
    name?: string | null;
    /**
     * 
     * @type {TeamMemberDto}
     * @memberof TeamDto
     */
    owner?: TeamMemberDto;
    /**
     * 
     * @type {PackageDto}
     * @memberof TeamDto
     */
    _package?: PackageDto;
}

export function TeamDtoFromJSON(json: any): TeamDto {
    return TeamDtoFromJSONTyped(json, false);
}

export function TeamDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'owner': !exists(json, 'owner') ? undefined : TeamMemberDtoFromJSON(json['owner']),
        '_package': !exists(json, 'package') ? undefined : PackageDtoFromJSON(json['package']),
    };
}

export function TeamDtoToJSON(value?: TeamDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'owner': TeamMemberDtoToJSON(value.owner),
        'package': PackageDtoToJSON(value._package),
    };
}


